<template>
    <div>
        <h1>Unhandled Task - {{ item.category }}</h1>
        <p>{{ item.description }}</p>
        <p>This type of task is currently not handled.</p>
        <pre>{{ json }}</pre>
        <button @click="ignore">Ignore</button>
    </div>
</template>
<script>
import TaskService from '@/services/manage/taskService'

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        json() {
            return JSON.stringify(this.item, null, 2)
        },
    },
    methods: {
        async ignore() {
            await TaskService.complete(this.item)
            this.$flash('Task cleared.', 'success')
        },
    },
}
</script>
